import type { AsanaV2 } from "@/types/asana-v2";

// Dynamic import of all V2 JSON files
const v2DataModules = import.meta.glob<{ default: AsanaV2 }>(
  "/src/data/asanas-v2/*.json",
  { eager: true }
);

// Dynamic import of all V2 Markdown content
const v2ContentModules = import.meta.glob<string>(
  "/src/content/asanas-v2/*.md",
  { eager: true, query: "?raw", import: "default" }
);

// Build lookup maps
export const asanaV2Data: Record<string, AsanaV2> = {};
export const asanaV2Content: Record<string, string> = {};

// Parse JSON modules
for (const path in v2DataModules) {
  const match = path.match(/\/([^/]+)\.json$/);
  if (match) {
    const slug = match[1];
    asanaV2Data[slug] = v2DataModules[path].default;
  }
}

// Parse Markdown modules
for (const path in v2ContentModules) {
  const match = path.match(/\/([^/]+)\.md$/);
  if (match) {
    const slug = match[1];
    asanaV2Content[slug] = v2ContentModules[path];
  }
}

// Get all available V2 asanas as sorted array
export const getV2AsanaList = (): AsanaV2[] => {
  return Object.values(asanaV2Data).sort((a, b) =>
    a.sanskrit.localeCompare(b.sanskrit, "de")
  );
};

// Get count of migrated asanas
export const getV2AsanaCount = (): number => {
  return Object.keys(asanaV2Data).length;
};

// Target count for progress display
export const V2_TARGET_COUNT = 25;
